import { render } from "./Modal.vue?vue&type=template&id=287bda95&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=287bda95&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-287bda95"

export default script